module.exports = __webpack_public_path__ + "09aac42a83718445e5ab3ce875f6412a.png";